import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { TOPBAR_SIZE, IMG } from '../../themes'
import { Loader, Topbar, TimePicker } from '../../components'
import { SearchAndSelect } from '../../components/SearchAndSelect'
import { FALLBACK_SPACE_TYPE_THEME, SPACE_TYPE, SPACE_TYPE_LABEL, SPACE_TYPE_LIST } from '../../helpers/constants/listRoom'
import Style from './style'
import {
  getNearestMinute,
  MENU,
  FLOORPLAN,
  PARAM_SEARCH,
  ROUTE,
  checkPermission,
  PERMISSION_PAGE,
  getLocaleDateStringFull,
  ROOM_STATUS,
  MAX_ROOM_LIST_LIMIT,
  MAX_DROPDOWN_LIMIT,
} from '../../helpers'
import apiService from '../../reduxs/apiService'
import ImageDisplay from './ImageDisplay'
import LinkOverlay from './LinkOverlay'


const oneHourTimeStamp = 1000 * 60 * 60
const oneDayTimeStamp = oneHourTimeStamp * 24

class FloorPlan extends Component {
  constructor(props) {
    super(props)
    const now = new Date().valueOf()
    const todayTimestamp = Math.floor(now / oneDayTimeStamp) * oneDayTimeStamp
    let selectedDate = this.initDatetime(new Date(props.params.year, props.params.month - 1, props.params.date, 0, -new Date().getTimezoneOffset()))
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date(todayTimestamp)
    this.initialState = {
      isLoading: false,
      bookingList: [],
      selectedDate: selectedDate,
      selectedTime: this.getInitialTime(props),
      isShowTimePicker: false,
      selectedBuilding: null,
      selectedFloor: null,
      buildingText: '',
      floorText: '',
      floorList: [],
      buildingList: [],
      roomList: [],
      isOpenSuggestBuilding: false,
      isOpenSuggestFloor: false,
      src: null,
      imageHeight: 0,
      imageWidth: 0,
      checkShowBuildingFistTime: false,
      checkShowFloorFistTime: false,
      permission: {
        read: checkPermission(props.permission, ROUTE.FLOORPLAN.CODE),
        create: checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.CREATE),
      },
      defaultBuilding: true,
      defaultFloor: true,
    }
    this.state = this.initialState
    this.restoreBuildingId = props.query && props.query.buildingId
    this.restoreFloorId = props.query && props.query.floorId

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("Floor Paln Page")
  }

  componentDidMount () {
    const { defaultBuilding, defaultFloor } = this.state
    const { userCompany, floor } = this.props
    floor.sort((a, b) => a.buildingName.localeCompare(b.buildingName))
    this.mapHasImageId = floor.find(result => Boolean(result.floorPlanImage))
    if (defaultBuilding && defaultFloor) {
      this.getListBuilding({
        ...PARAM_SEARCH.BUILDING,
        buildingName: '',
        ordering: 'buildings.name ASC',
        companyId: userCompany,
        limit: MAX_DROPDOWN_LIMIT
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const props = { ...this.props }
    const { selectedFloor, buildingList, floorText } = this.state
    let selectedDate = new Date(props.params.year, props.params.month - 1, props.params.date, 0, -new Date().getTimezoneOffset())
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    if (selectedDate.valueOf() !== this.state.selectedDate.valueOf()) {
      Object.assign(this.initialState, {
        isLoading: false,
        selectedDate: selectedDate
      })
      this.setState({
        selectedDate: selectedDate
      })
      if (this.state.selectedFloor) {
        this.loadFloorPlan(selectedFloor.id, selectedDate)
      }
    }

    if (buildingList.length === 1 && prevState.floorText !== floorText) {
      this.setState({
        selectedFloor,
        floorText,
        floorList: []
      })

      if (selectedFloor && selectedFloor.id !== null) {
        this.loadFloorPlan(selectedFloor.id)
      }
    }
  }

  getMinuteStep (props = this.props) {
    return Number(props.minuteStep) > 0 ? Number(props.minuteStep) : 15
  }

  getOperatingRange (date, props = this.props) {
    const minuteStep = this.getMinuteStep(props)
    const toMinutes = (timeString, fallback) => {
      const [hour, minute, second] = String(timeString || fallback).split(':').map(Number)
      if (isNaN(hour)) return toMinutes(fallback, fallback)
      return hour * 60 + (minute || 0) + (second || 0) / 60
    }
    const startMinutes = Math.ceil(toMinutes(props.startOperatingTime, '00:00:00') / minuteStep) * minuteStep
    const endMinutes = Math.ceil(toMinutes(props.endOperatingTime, '23:59:59') / minuteStep) * minuteStep - minuteStep
    const toDate = (minutes) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, minutes)
    if (endMinutes < startMinutes) {
      return { start: toDate(0), end: toDate(24 * 60 - minuteStep) }
    }
    return { start: toDate(startMinutes), end: toDate(endMinutes) }
  }

  clampTime (time, props = this.props) {
    const { start, end } = this.getOperatingRange(time, props)
    if (time < start) return start
    if (time > end) return end
    return time
  }

  getInitialTime (props) {
    const minuteStep = this.getMinuteStep(props)
    const queryTime = props.query && /^\d{1,2}:\d{2}$/.test(props.query.time || '') ? props.query.time.split(':').map(Number) : null
    const now = new Date()
    const minutes = queryTime
      ? queryTime[0] * 60 + queryTime[1]
      : Math.ceil((now.getHours() * 60 + now.getMinutes()) / minuteStep) * minuteStep
    return this.clampTime(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, minutes), props)
  }

  toDateTimeString (dateTime) {
    const dateString = [dateTime.getFullYear(), (dateTime.getMonth() + 1).toString().padStart(2, 0), dateTime.getDate().toString().padStart(2, 0)].join('-')
    const timeString = [dateTime.getHours().toString().padStart(2, 0), dateTime.getMinutes().toString().padStart(2, 0), '00'].join(':')
    return [dateString, timeString].join(' ')
  }

  toTimeString (time) {
    return [time.getHours(), time.getMinutes()].map(value => value.toString().padStart(2, '0')).join(':')
  }

  loadFloorPlan (floorId, selectedDate = this.state.selectedDate, selectedTime = this.state.selectedTime) {
    const dateTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), selectedTime.getHours(), selectedTime.getMinutes())
    this.getDetailFloorPlan({
      floorId,
      startDatetime: this.toDateTimeString(dateTime),
      endDatetime: this.toDateTimeString(dateTime)
    }, dateTime)
  }

  selectTime (selectedTime) {
    const { selectedFloor, selectedDate } = this.state
    this.setState({ selectedTime, isShowTimePicker: false })
    if (selectedFloor) {
      this.loadFloorPlan(selectedFloor.id, selectedDate, selectedTime)
    }
  }

  async getListBuilding(params) {
    this.setState({ isLoading: true })

    try {
      const { status, data } = await apiService.get('rest/v1/getlist_building2', params)
      this.handleBuildingResponse(status, data)
    } catch (error) {
      console.error('ERROR ACTION getListAllBooking2', error.message)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  handleBuildingResponse(status, data) {
    if (status) {
      const buildingList = data.list
      const buildingCount = buildingList.length;
      const isOneBuilding = buildingCount === 1

      if (isOneBuilding) {
        this.handleSingleBuildingCase(buildingList[0])
      } else {
        this.handleOtherCases(buildingList)
      }
    } else {
      this.props.openModalStatus(data)
    }
  }

  handleSingleBuildingCase(building) {
    const { buildingId, buildingName } = building
    const selectedBuilding = { id: buildingId, name: buildingName }

    this.setState({
        buildingList: [selectedBuilding],
        selectedBuilding,
        buildingText: buildingName,
    })

    this.selectBuilding(selectedBuilding);
    this.getListFloor({ buildingId, companyId: this.props.userCompany, limit: MAX_DROPDOWN_LIMIT })
  }

  handleOtherCases(buildingList) {
    const mappedBuildingList = buildingList.map((building) => ({
      id: building.buildingId,
      name: building.buildingName,
    }))
    this.setState({
      buildingList: mappedBuildingList,
      checkShowFloorFistTime: false,
    })

    const restoreBuilding = mappedBuildingList.find(building => String(building.id) === String(this.restoreBuildingId))
    this.restoreBuildingId = null
    if (restoreBuilding) {
      this.selectBuilding(restoreBuilding)
      this.searchFloor('', false, restoreBuilding)
    } else {
      this.restoreFloorId = null
    }
  }

  async getListFloor(params) {
    this.setState({ isLoading: true })

    try {
      const { status, data } = await apiService.get('rest/v1/getlist_floor', params)
      this.handleFloorResponse(status, data)
    } catch (error) {
      console.error('ERROR ACTION getListAllBooking2', error.message)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  handleFloorResponse(status, data) {
    if (status) {
      const floorList = data.list
      const isOneBuilding = this.state.buildingList.length === 1
      const isOneFloor = floorList.length === 1

      if (isOneBuilding && isOneFloor) {
        this.restoreFloorId = null
        this.handleSingleBuildingAndFloorCase(floorList[0])
      }

      this.filterAndSetFloorList(floorList)
      this.restoreFloor(floorList)
    } else {
      this.props.openModalStatus(data)
    }
  }

  handleSingleBuildingAndFloorCase(floor) {
    const { floorId, floorLevel } = floor

    this.setState({
      checkShowFloorFistTime: true,
      selectedFloor: { id: floorId, name: floorLevel },
      floorText: floorLevel,
    })
  }

  filterAndSetFloorList(floorList) {
    const floorFilter = floorList
      .filter(floor => floor.status === 0)
      .map(floor => ({
        id: floor.floorId,
        name: floor.floorLevel,
      }))

    this.setState({ floorList: floorFilter })
  }

  restoreFloor(floorList) {
    if (!this.restoreFloorId) return
    const restoreFloor = floorList.find(floor => floor.status === 0 && String(floor.floorId) === String(this.restoreFloorId))
    this.restoreFloorId = null
    if (restoreFloor) {
      this.selectFloor({ id: restoreFloor.floorId, name: restoreFloor.floorLevel })
    }
  }

  getDetailFloorPlan (param, dateTime) {
    this.setState({
      isLoading: true
    })
    const requestId = (this.floorPlanRequestId || 0) + 1
    this.floorPlanRequestId = requestId
    return Promise.all([
      apiService.get('rest/v1/getdetail_floor', param),
      apiService.get('rest/v2/room/', { floorId: param.floorId, coord: true, limit: MAX_ROOM_LIST_LIMIT, status: ROOM_STATUS.ACTIVE, dateTimeNow: dateTime.toISOString(), includeOwner: true })
    ]).then(([res, roomsRes]) => {
      if (requestId !== this.floorPlanRequestId) return
      this.setState({
        isLoading: false
      })
      if (res.status) {
        let listRoom = []
        if (roomsRes && roomsRes.status && roomsRes.data) {
          const rawData = roomsRes.data
          if (Array.isArray(rawData)) listRoom = rawData
          else if (Array.isArray(rawData.list)) listRoom = rawData.list
          else if (Array.isArray(rawData.rooms)) listRoom = rawData.rooms
          else if (Array.isArray(rawData.roomList)) listRoom = rawData.roomList
        }
        
        const normalizedListRoom = listRoom.map(room => ({
          ...room,
          roomId: room.roomId || room.id || room.spaceId,
          roomName: room.roomName || room.name || room.spaceName || '',
        })).filter(room => room.roomId && room.coord);

        res = res.data
        this.setState({
          roomList: normalizedListRoom,
          imageHeight: res.imageHeight,
          imageWidth: res.imageWidth,
          src: res.imageBase64
        })
      } else if (!res.status) {
        this.props.openModalStatus(res)
      } else {
      }
    }).catch((err) => {
      if (requestId !== this.floorPlanRequestId) return
      this.setState({ isLoading: false })
      console.error(err)
    })
  }

  initDatetime (selectedDate) {
    const minuteStep = this.state && this.state.minuteStep ? this.state.minuteStep : 15
    let minute = getNearestMinute(selectedDate.getMinutes(), minuteStep, 1)
    let hour = selectedDate.getHours()
    let now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    if (minute >= 60) {
      minute = 0
      hour = hour + 1
      if (hour >= 24) {
        now = null
      }
    }
    if (now !== null) now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    return now
  }

  searchFloor (text, forceSearch = false, selectBuilding = this.state.selectedBuilding) {
    const { userCompany } = this.props
    const number = parseInt(text)

    if (!isNaN(number) || !text.trim()) {
      this.setState({
        selectedFloor: null,
        floorText: text,
      })
      if (selectBuilding || forceSearch) {
        this.getListFloor({
          ...PARAM_SEARCH.FLOOR,
          floorLevel: !isNaN(number) ? number : undefined,
          buildingId: selectBuilding.id,
          sorts: JSON.stringify([
            {
              "type":"ASC",
              "column":"floorLevel"
            }
          ]),
          companyId: userCompany,
          limit: MAX_DROPDOWN_LIMIT
        })
      }

      ReactGA.event({
        category: 'Floorplan',
        action: 'Search_Floor',
      })
    }
  }

  selectBuilding (building) {
    this.setState({
      selectedBuilding: building,
      buildingText: building.name,
      defaultBuilding: false
    })
  }

  selectFloor (floor) {
    const { selectedDate, selectedBuilding } = this.state

    if (!selectedBuilding) {
      return
    }

    this.setState({
      selectedFloor: floor,
      floorText: floor.name,
      defaultFloor: false
    })
    this.loadFloorPlan(floor.id, selectedDate)
  }

  deselectBuilding () {
    this.setState({
      selectedBuilding: null,
      buildingText: '',
      floorList: [],
      defaultBuilding: false,
      isOpenSuggestBuilding: true,
    })
    this.deselectFloor()
  }

  deselectFloor () {
    this.setState({
      selectedFloor: null,
      floorText: '',
      roomList: [],
      src: null,
      imageHeight: 0,
      imageWidth: 0,
      defaultFloor: false,
    })
  }

  clearSearchBuilding() {
    this.setState({
      buildingText: '',
      floorText: ''
    })
  }

  clearSearchFloor() {
    this.setState({
      floorText: '',
    })
  }

  filterOptions(options, search) {
    if(search) {
      let newSearch = search.toString().toLowerCase()
      return options.filter(item => `${item.name}`.toLowerCase().includes(newSearch))
    }
    return options
  }

  handleClickLink (id) {
    const { date, month, year } = this.props.params
    if (!this.state.permission.create) {
      this.props.history.push(`${ROUTE.FLOORPLAN.CALENDAR}/${id}/${year}/${month}/${date}`)
      return
    }
    const { selectedBuilding, selectedFloor, selectedTime } = this.state
    const dateString = [year, month.toString().padStart(2, '0'), date.toString().padStart(2, '0')].join('-')
    const locationQuery = selectedBuilding && selectedFloor ? `&buildingId=${selectedBuilding.id}&floorId=${selectedFloor.id}&time=${this.toTimeString(selectedTime)}` : ''
    this.props.history.push(`${ROUTE.BOOKING.LINK}/create?date=${dateString}&roomId=${id}&from=floorplan${locationQuery}`)
  }

  render () {
    const { language, settingTheme } = this.props
    const {
      isLoading,
      selectedBuilding,
      selectedFloor,
      buildingText,
      floorText,
      buildingList,
      floorList,
      imageHeight,
      imageWidth,
      isOpenSuggestBuilding,
      isOpenSuggestFloor,
      roomList,
      src,
      permission,
      checkShowBuildingFistTime,
      checkShowFloorFistTime,
      selectedDate,
      selectedTime,
      isShowTimePicker,
    } = this.state
    const { colorTheme } = settingTheme
    const operatingRange = this.getOperatingRange(selectedDate)

    const { date, month, year } = this.props.params
    const displayDate = new Date(year, month - 1, date)

    return (
      <Style colorTheme={colorTheme}>
        
        {isLoading && <Loader colorTheme={colorTheme} />}

        <Topbar
          height={TOPBAR_SIZE.LV_2}
          textBreadcrumbStart={MENU.FLOOR_PLAN[language]}
          textCenter={getLocaleDateStringFull(displayDate, language)}
          addonComponent={() => (
            <React.Fragment />
          )}
        />

        <div className='body'>
          <div className='box-filters'>
            <SearchAndSelect
              typeIcon='autosuggest'
              icon='ic_expand-more-gray.svg'
              placeholder={FLOORPLAN.SEARCH_BUILDING[language]}
              classInput='input-data'
              className='box-search-building'
              keyword={buildingText}
              onChangeSearch={(event) => this.setState({buildingText: event.target.value})}
              list={this.filterOptions(buildingList, buildingText)}
              onClickList={(building) => {
                this.selectBuilding(building)
                this.searchFloor('', false, building)
              }}
              clearSearch={() => {
                this.deselectBuilding()
              }}
              onFocus={() => {
                this.clearSearchBuilding()
                this.setState({isOpenSuggestBuilding: true})
              }}
              onBlur={() => this.setState({isOpenSuggestBuilding: false})}
              isOpenDropdown={isOpenSuggestBuilding}
              language={language}
              disabled={checkShowBuildingFistTime}
              colorTheme={colorTheme}
            />

            <SearchAndSelect
              type='number'
              typeIcon='autosuggest'
              icon='ic_expand-more-gray.svg'
              placeholder={FLOORPLAN.SEARCH_FLOOR[language]}
              classInput='input-data'
              className='box-search-floor'
              keyword={floorText}
              onChangeSearch={(event) =>this.setState({floorText: event.target.value})}
              list={this.filterOptions(floorList, floorText)}
              onClickList={(floor) => this.selectFloor(floor)}
              clearSearch={() => {
                this.deselectFloor()
                this.setState({ isOpenSuggestFloor: true })
              }}
              onFocus={() =>{
                this.clearSearchFloor()
                this.setState({isOpenSuggestFloor: true})
              }}
              onBlur={() => this.setState({isOpenSuggestFloor: false})}
              isOpenDropdown={isOpenSuggestFloor}
              language={language}
              disabled={checkShowFloorFistTime || !selectedBuilding}
              colorTheme={colorTheme}
            />

            <button
              type='button'
              className='box-select-time'
              onClick={() => this.setState({ isShowTimePicker: true })}
            >
              <img src={IMG['time.svg']} alt='' className='icon-time' />
              <span className='text-time'>{this.toTimeString(selectedTime)}</span>
              <img src={IMG['ic_expand-more-gray.svg']} alt='' className='icon-expand' />
            </button>
          </div>
          {isShowTimePicker &&
            <TimePicker
              selectTime={selectedTime}
              selectedDate={selectedDate}
              startSelectable={operatingRange.start}
              endSelectable={operatingRange.end}
              minuteStep={this.getMinuteStep()}
              handleCloseButton={() => this.setState({ isShowTimePicker: false })}
              handleSaveButton={(event, time) => this.selectTime(time)}
              language={language}
              colorTheme={colorTheme}
            />
          }
          <section className='box-legend'>
            <div className='legend-status'>
              <div className='legend-item'>
                <span className='status-dot status-dot--available' />
                <span className='legend-text'>{FLOORPLAN.AVAILABLE[language]}</span>
              </div>
              <div className='legend-item'>
                <span className='status-dot status-dot--busy' style={{ backgroundColor: colorTheme }} />
                <span className='legend-text'>{FLOORPLAN.BUSY[language]}</span>
              </div>
            </div>
            <div className='legend-types'>
              {SPACE_TYPE_LIST.map(type => {
                const theme = settingTheme?.themeConfig?.spaceType?.[type] || FALLBACK_SPACE_TYPE_THEME[type] || FALLBACK_SPACE_TYPE_THEME.other;
                const bg = theme.background || theme.bg;
                const fg = theme.foreground || theme.text;
                return (
                  <div className='legend-item' key={type}>
                    <div className='legend-icon-wrapper' style={{ backgroundColor: bg }}>
                      <div
                        style={{
                          width: '18px',
                          height: '18px',
                          backgroundColor: fg,
                          mask: `url(${IMG[`ic_${type}.svg`]}) no-repeat center / contain`,
                          WebkitMask: `url(${IMG[`ic_${type}.svg`]}) no-repeat center / contain`
                        }}
                      />
                    </div>
                    <span className='legend-text'>{SPACE_TYPE_LABEL[type][language]}</span>
                  </div>
                );
              })}
            </div>
          </section>
          {permission.read
            ? (
              <div className='box-content'>
                <section className='content'>
                  <ImageDisplay
                    src={src}
                    isShowing={Boolean(selectedFloor)}
                    language={language}
                  />
                  <LinkOverlay
                    roomList={roomList}
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                    handleClick={(event, id) => this.handleClickLink(id)}
                    settingTheme={settingTheme}
                    themeConfig={settingTheme?.themeConfig}
                  />
                </section>
              </div>
            )
            : <div style={{ margin: 'auto' }}>{PERMISSION_PAGE.NOT_FOUND[language]}</div>
          }
        </div>
      </Style>
    )
  }
}

export default FloorPlan

